<template>
    <div class="class-1">
      <!-- Header -->
      <AppHeader title="Edit Product" />
  
      <!-- Product Form -->
      <div class="container mt-4">
        <div class="row">
          <div class="col-12">
            <h2>Product Details</h2>
            <form @submit.prevent="submitForm">
              <!-- Name Inputs for Each Language -->
              <div class="form-row" v-for="language in languages" :key="language.id">
                <div class="form-group col-md-12">
                  <label :for="`name_${language.id}`">Name ({{ language.fullName }})</label>
                  <input
                    type="text"
                    class="form-control"
                    :id="`name_${language.id}`"
                    :placeholder="`Enter Product Name in ${language.fullName}`"
                    v-model="form.names[language.id]"
                  >
                </div>
              </div>
  
              <!-- Price and Cost -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="price">Price</label>
                  <input
                    type="number"
                    step="0.01"
                    class="form-control"
                    id="price"
                    v-model="form.price"
                    required
                  >
                </div>
                <!-- <div class="form-group col-md-6">
                  <label for="cost">Cost</label>
                  <input
                    type="number"
                    step="0.01"
                    class="form-control"
                    id="cost"
                    v-model="form.cost"
                  >
                </div> -->
              </div>
  
              <!-- Preparation Time -->
              <!-- <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="prepare">Preparation Time (minutes)</label>
                  <input
                    type="number"
                    class="form-control"
                    id="prepare"
                    v-model="form.prepare"
                  >
                </div>
              </div> -->
  
              <!-- ERP Item -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="erpItem">ERP Item Code</label>
                  <input
                    type="text"
                    class="form-control"
                    id="erpItem"
                    v-model="form.ERP_Item"
                  >
                </div>
              </div>
                 <!-- barcode -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="erpItem">BarCode</label>
                  <input
                    type="text"
                    class="form-control"
                    id="erpItem"
                    v-model="form.barcode"
                  >
                </div>
              </div>
              <!-- Barcode Type -->
<div class="form-row">
  <div class="form-group col-md-12">
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        id="hasBarcode"
        v-model="hasBarcode"
        @change="handleBarcodeToggle"
      >
      <label class="form-check-label" for="hasBarcode">Has Barcode</label>
    </div>
    
    <div v-if="hasBarcode" class="ml-4 mt-2">
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="barcodeTypeQuantity"
          v-model="form.barcode_type"
          :value="0"
          :disabled="!hasBarcode"
        >
        <label class="form-check-label" for="barcodeTypeQuantity">Quantity</label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="barcodeTypeRate"
          v-model="form.barcode_type"
          :value="1"
          :disabled="!hasBarcode"
        >
        <label class="form-check-label" for="barcodeTypeRate">Rate</label>
      </div>
    </div>
  </div>
</div>
              <!-- Status Checkboxes -->
              <!-- <div class="form-row">
                <div class="form-group col-md-12">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="isSuspend"
                      v-model="form.isSuspend"
                    >
                    <label class="form-check-label" for="isSuspend">Suspend Product</label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="isHotKey"
                      v-model="form.isHotKey"
                    >
                    <label class="form-check-label" for="isHotKey">Hot Key Item</label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="isDualMenu"
                      v-model="form.isDualMenu"
                    >
                    <label class="form-check-label" for="isDualMenu">Dual Menu Item</label>
                  </div>
                </div>
              </div>
   -->
              <!-- Product Image -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="productImage">Product Image</label>
                  <input
                    type="file"
                    class="form-control-file"
                    id="productImage"
                    @change="handleImageUpload"
                  >
                  <img v-if="form.existingImage" :src="form.existingImage" class="img-thumbnail mt-2" style="max-width: 200px;">
                </div>
              </div>
  
              <!-- Buttons -->
              <div class="form-row">
                <div class="form-group col-12 d-flex justify-content-between">
                  <button type="button" class="btn btn-secondary" @click="cancelForm">Cancel</button>
                  <button type="submit" class="btn editproduct">Update Product</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  
      <!-- Footer -->
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
    data() {
  return {
    languages: [],
    currentDate: "",
    currentTime: "",
    productId: this.$route.params.id,
    hasBarcode: false, // Add this
    form: {
      catId: "",
      cost: "",
      price: "",
      prepare: "",
      image: null,
      existingImage: null,
      names: {},
      isSuspend: false,
      isHotKey: false,
      ERP_Item: "",
      barcode: "",
      barcode_type: 0, // Add this (default to 0 - quantity)
      isDualMenu: false
    },
  };
},
    created() {
      this.fetchProducts();
      this.fetchProduct();
      this.updateDateTime();
      setInterval(this.updateDateTime, 1000);
      
      const storedLanguages = localStorage.getItem('languages');
      if (storedLanguages) {
        this.languages = JSON.parse(storedLanguages).reverse();
      }
    },
    methods: {
      async fetchProduct() {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const token = localStorage.getItem('authToken');
          const response = await fetch(`${this.$BASE_API_URL}/api/products/${this.productId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          
          if (response.ok) {
            const data = await response.json();
            if (data.status) {
              this.populateForm(data.data);
            }
          } else {
            throw new Error('Failed to fetch product');
          }
        } catch (error) {
          console.error("Error fetching product:", error);
          this.$toast.error('Error loading product data');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      
      populateForm(productData) {
          this.hasBarcode = !!productData.barcode || productData.barcode_type !== undefined;
        this.form = {
          catId: productData.catId,
          cost: productData.cost|| 0,
          price: productData.price,
          prepare: productData.prepare,
          image: null,
          existingImage: productData.image,
          names: {},
          isSuspend: Boolean(productData.isSuspend),
          isHotKey: Boolean(productData.isHotKey),
          ERP_Item: productData.ERP_Item || "",
          barcode: productData.barcode || "",
          barcode_type: productData.barcode_type !== undefined ? productData.barcode_type : 0,
           isDualMenu: Boolean(productData.isDualMenu)
        };
        
        // Populate names for each language
        if (productData.languages && productData.languages.length > 0) {
          productData.languages.forEach(lang => {
            this.form.names[lang.langId] = lang.name;
          });
        }
      },
      
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        this.currentTime = now.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      },
       handleBarcodeToggle() {
    if (!this.hasBarcode) {
      this.form.barcode_type = 0;
    }
  },
      handleImageUpload(event) {
        const file = event.target.files[0];
        if (file) {
          this.form.image = file;
          this.form.existingImage = URL.createObjectURL(file); 
        }
      },
      
      cancelForm() {
        this.$router.push(`/catproducts/${this.form.catId}`);
      },
      async fetchProducts() {
        const token = localStorage.getItem('authToken');
  try {
    this.$root.isLoading = true; 
          this.loading = true;
    const response = await axios.get(`${this.$BASE_API_URL}/api/products`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    
    if (response.data.status) {
      const allProducts = response.data.data || [];
      
      this.products = this.$route.params.id 
        ? allProducts.filter(product => product.catId == this.form.catId)
        : allProducts;
      
      console.log('Fetched products:', this.products);
    }
  } catch (error) {
    console.error("Error fetching products:", error);
    this.$toast.error("Failed to load products");
  }
  finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
},
      async submitForm() {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const formData = new FormData();
          
          // Append basic fields
          formData.append('catId', this.form.catId);
          formData.append('cost', this.form.cost);
          formData.append('price', this.form.price);
          formData.append('prepare', this.form.prepare);
          formData.append('isSuspend', this.form.isSuspend ? "1" : "0");
          formData.append('isHotKey', this.form.isHotKey ? "1" : "0");
          formData.append('ERP_Item', this.form.ERP_Item);
          formData.append('barcode', this.form.barcode);
          formData.append('isDualMenu', this.form.isDualMenu ? "1" : "0");
          formData.append('barcode_type', this.hasBarcode ? this.form.barcode_type.toString() : "0"); 
          this.languages.forEach((language, index) => {
            formData.append(`names[${index}][langId]`, language.id.toString());
            formData.append(`names[${index}][name]`, this.form.names[language.id] || '');
          });
          
          if (this.form.image) {
            formData.append('image', this.form.image);
          }
          console.log(this.languages);
          console.log(this.products);

          const isDuplicate = this.products.some(product => {
      // Skip current product
      if (product.id == this.productId) return false;
      
      // Ensure product has languages data
      if (!product.languages || !Array.isArray(product.languages)) return false;
      
      // Check for any matching names across languages
      return this.languages.some(lang => {
        const existingLang = product.languages.find(l => l.langId == lang.id);
        if (!existingLang) return false; // No matching language
        
        const existingName = existingLang.name?.trim().toLowerCase();
        const newName = (this.form.names[lang.id] || '').trim().toLowerCase();
        
        return existingName && newName && existingName === newName;
      });
    });

    if (isDuplicate) {
      this.$toast.error('A product with one or more of these names already exists');
      return;
    }
          const token = localStorage.getItem('authToken');
          
          const response = await fetch(`${this.$BASE_API_URL}/api/products/update/${this.productId}`, {
            method: 'POST', // or PUT depending on your API
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: 'application/json',
            },
            body: formData,
          });
          
          if (response.ok) {
            this.$toast.success('Product updated successfully!');
            this.$router.push(`/catproducts/${this.form.catId}`);
          } else {
            const errorData = await response.json();
            this.$toast.error(errorData.message || 'Failed to update product');
          }
        } catch (error) {
          console.error('Error updating product:', error);
          this.$toast.errors('An error occurred while updating the product');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      }
    },
  };
  </script>
  
  <style scoped>
  .class-1 {
    font-family: 'Poppins', sans-serif;
  }
  
  .logo_icon {
    max-width: 100px;
  }
  
  .editproduct {
    background-color: #2196F3;
    color: #fff;
  }
  
  /* Add any additional styles here */
  </style>